import {
    ChangeDetectionStrategy,
    Component,
    inject,
    signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AIActions } from '@modules/ai/store/ai.actions';
import { selectIsPanelAnimating } from '@modules/ai/store/ai.selectors';
import { Store } from '@ngrx/store';
import { distinctUntilChanged } from 'rxjs';

@Component({
    selector: 'interacta-ai-panel-overlay',
    templateUrl: './ai-panel-overlay.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AIPanelOverlayComponent {
    private store = inject(Store);

    showContent = signal<boolean>(false);

    constructor() {
        this.store
            .select(selectIsPanelAnimating)
            .pipe(distinctUntilChanged(), takeUntilDestroyed())
            .subscribe((value) => this.showContent.set(!value));
    }

    close(): void {
        this.store.dispatch(AIActions.toggleAIPanel({ isOpen: false }));
    }
}
